// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkDoneSection_wrapper__yYWBt","logo":"WorkDoneSection_logo__HNNza","title":"WorkDoneSection_title__z9Cgv","description":"WorkDoneSection_description__3wD6k"};